(() => {
  const storySelector = '.ks-barbell-story, .ks-gear-story, .ks-handles-story, .ks-weights-story';
  const initialize = scope => {
    scope.querySelectorAll(storySelector).forEach(story => {
      story.querySelectorAll('table').forEach(table => {
        if (table.closest('.ks-pdp-table-scroll') || table.querySelector('table') || table.closest('table table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'ks-pdp-table-scroll';
        if ([...table.rows].some(row => [...row.cells].reduce((count, cell) => count + cell.colSpan, 0) > 3)) wrapper.classList.add('ks-pdp-table-scroll--wide');
        table.before(wrapper);
        wrapper.append(table);
        const update = () => {
          if (wrapper.scrollWidth > wrapper.clientWidth + 1) {
            wrapper.tabIndex = 0;
            wrapper.setAttribute('role', 'region');
            wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || window.KensuiCopy("508efd6868d485a060","Product information table",[]));
          } else {
            wrapper.removeAttribute('tabindex');
            wrapper.removeAttribute('role');
            wrapper.removeAttribute('aria-label');
          }
        };
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(wrapper);
        update();
      });
      story.querySelectorAll('video[data-src][controls]:not([src])').forEach(video => {
        if (video.dataset.ksPolishReady || video.closest('ks-product, [data-ks-gallery], .cpr-reel, .cpr-card')) return;
        video.dataset.ksPolishReady = 'true';
        video.classList.add('ks-pdp-story-video');
        video.removeAttribute('tabindex');
        const load = () => {
          if (video.getAttribute('src')) return;
          video.src = video.dataset.src;
          video.preload = 'metadata';
          video.load();
        };
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { load(); observer.disconnect(); }
          }, {rootMargin: '500px'});
          observer.observe(video);
        } else load();
        video.addEventListener('pointerdown', load, {once: true});
        video.addEventListener('focus', load, {once: true});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

